import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';

import moStore, { toggleValue } from '@store/index';
import moUser from '@store/user';
import moLogin, { toggleLogin } from '@store/login';
import WorkService from '@/service/work';
import localforage from 'localforage';

const moHumanIndustry = observable({
  industryTabActive: '多指标',
  industryTimeActive: '2018',
  avtiveShow: 'chart',
  industryList: <any>{},
});


// 修改tab
const changeTab = action(async (val: string) => {
  runInAction(() => {
    moHumanIndustry.industryTabActive = val;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.industrytab = val;
  localforage.setItem('humans', humanData);
});

// 修改默认tab

const changeIndustryTab = action(async (val: string) => {
  runInAction(() => {
    moHumanIndustry.industryTabActive = val;
  });
});

// 修改时间tab
const changeTimeTab = action(async (val: string) => {
  runInAction(() => {
    moHumanIndustry.industryTimeActive = val;
  });
  const list = await WorkService.humanEfficiencyIndustry({
    year: val,
  });
  runInAction(() => {
    moHumanIndustry.industryList = list;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.industrytime = val;
  localforage.setItem('humans', humanData);
});

// 修改默认时间

const changeDefaltIndustry = action(async (val: string) => {
  runInAction(() => {
    moHumanIndustry.industryTimeActive = val;
  });
});

// 展示chart或者表格

const changeShow = action(async (val: string) => {
  runInAction(() => {
    moHumanIndustry.avtiveShow = val;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.industrytable = val;
  localforage.setItem('humans', humanData);
});

// 展示chart或者表格

const changeIndustryShow = action(async (val: string) => {
  runInAction(() => {
    moHumanIndustry.avtiveShow = val;
  });
});

// 获取数据

const getHumanEfficiencyIndustry = action((list: any) => {
  runInAction(() => {
    moHumanIndustry.industryList = list;
  });
});

export default moHumanIndustry;
export {
  changeTab, changeTimeTab, changeShow, getHumanEfficiencyIndustry, changeDefaltIndustry,
  changeIndustryTab, changeIndustryShow,
};
